/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: gatewaySipProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Gateway SIP Profiles module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteGatewaySipProfile } from './api';

/**
 * Shared helpers for Gateway SIP Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Gateway SIP Profile in the form.
 * Pattern: /settings/technology/gateway-profile/new?duplicate={id}
 */
export const getGatewaySipProfileDuplicateUrl = (id: string | number): string =>
  `/settings/technology/gateway-profile/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Gateway SIP Profile id.
 */
export const navigateToGatewaySipProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getGatewaySipProfileDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Gateway SIP Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteGatewaySipProfile from './api' instead
 */
export const deleteGatewaySipProfileById = async (id: string | number): Promise<void> => {
  await deleteGatewaySipProfile(id);
};

